import { loadPayPalAnalytics } from './load-paypal-analytics'
import { getPgrp } from './get-pgrp'
/**
 * Starts CPL tracking
 * @param {String} identifier for identifying which recordCplEnd to pair up with
 * @param {Object} data object containing pgrp and page properties to track
 */
export function recordCplStart(identifier, data) {
  if (!data) {
    const pathList = window.location.pathname
      .replace(/(^\/|\/$)/g, '')
      .split('/')
    const path = getPgrp(pathList)
    const pgrp =
      path[path.length - 1] === 'sandbox' || path[path.length - 1] === 'live'
        ? path.slice(0, -1).join(':')
        : path.join(':')
    const page = path.join(':')
    data = {
      pgrp,
      page,
    }
  }
  if (!window.PAYPAL || !window.PAYPAL.analytics) loadPayPalAnalytics()
  try {
    if (identifier) window.PAYPAL.analytics.startCPLTracking(data, identifier)
    else window.PAYPAL.analytics.startCPLTracking(data)
  } catch {
    return
  }
}
